// src/components/CategoryBar.js
import React, { useState, useRef } from "react";
import "../styles/category.css";
import SearchBar from "./SearchBar";

// Import your category images
import bellIcon from "../assets/bell-icon.png";
import phone from "../assets/vecteezy_3d-blank-phone-screen-isolated-on-transparent-background_47242126.png";
import Watches from "../assets/vecteezy_realistic-watch-clipart-design-illustration_9379868.png";
import Laptops from "../assets/vecteezy_ai-generated-laptop-blank-screen-png-isolated-on-transparent_35875537.png";
import beauty from "../assets/vecteezy_cosmatice-and-makeup-brushes-ai-generative_32160128.png";
import Cars from "../assets/vecteezy_modern-luxury-car-isolated-on-transparent-background_47242694.png";
import Appliances from "../assets/vecteezy_a-coffee-maker-coffee-cup-and-knife-on-a-white-background_47308609.png";
import Fragrances from "../assets/vecteezy_ai-generated-perfume-bottlle-on-transparent-background_39557834.png";
import Eyewear from "../assets/vecteezy_eye-with_26771813.png";
import Gaming from "../assets/vecteezy_3d-render-game-equipment-console-headset_13361342.png";
import Televisions from "../assets/vecteezy_high-definition-television-lineup_55209908.png";
import mens from "../assets/men.png";
import womens from "../assets/women.png";
import kids from "../assets/kids.png";
import Sports from "../assets/sports.png";
import deals from "../assets/deals.png";

const categories = [
  { name: "Watches", image: Watches },
  { name: "Mobiles", image: phone },
  { name: "Laptops", image: Laptops },
  { name: "Beauty", image: beauty },
  { name: "Cars", image: Cars },
  { name: "Appliances", image: Appliances },
  { name: "Fragrances", image: Fragrances },
  { name: "Eyewear", image: Eyewear },
  { name: "Gaming", image: Gaming },
  { name: "Televisions", image: Televisions },
  { name: "Men's", image: mens },
  { name: "Women's", image: womens },
  { name: "Kid's", image: kids },
  { name: "Sports", image: Sports },
  { name: "Deals", image: deals }
];

function CategoryBar({ onCategoryClick }) {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 5;
  const containerRef = useRef(null);
  const [scrollX, setScrollX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);

  const handleTouchStart = (e) => {
    setIsDragging(true);
    dragStartX.current = e.touches[0].clientX - scrollX;
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const newScrollX = e.touches[0].clientX - dragStartX.current;
    setScrollX(newScrollX);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    if (scrollX < -50) {
      setStartIndex((prev) => Math.min(prev + 3, categories.length - visibleCount));
    } else if (scrollX > 50) {
      setStartIndex((prev) => Math.max(prev - 3, 0));
    }
    setScrollX(0);
  };

  const handleArrowClick = (direction) => {
    if (direction === "left") {
      setStartIndex((prev) => Math.max(prev - 3, 0));
    } else {
      setStartIndex((prev) => Math.min(prev + 3, categories.length - visibleCount));
    }
  };

  const handleCategoryClick = (categoryName) => {
    if (onCategoryClick) {
      onCategoryClick(categoryName); // Trigger filter on Home
    }
  };

  return (
    <div>
      <div className="category-bar-wrapper">
        <button className="scroll-btn left" onClick={() => handleArrowClick("left")} disabled={startIndex === 0}>❮</button>
        <div
          className="category-bar-container"
          ref={containerRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="category-bar" style={{ transform: `translateX(${scrollX}px)`, transition: isDragging ? "none" : "transform 0.2s ease-out" }}>
            {categories.slice(startIndex, startIndex + visibleCount).map((category, index) => (
              <div
                className="category-item center"
                key={index}
                onClick={() => handleCategoryClick(category.name)}
              >
                <img src={category.image} alt={category.name} className="category-image" />
                <span className="category-name">{category.name}</span>
              </div>
            ))}
          </div>
        </div>
        <button className="scroll-btn right" onClick={() => handleArrowClick("right")} disabled={startIndex >= categories.length - visibleCount}>❯</button>
      </div>

      {/* Search bar shown below the category bar */}
      <div className="search-bar-wrapper">
        <SearchBar />
      </div>
    </div>
  );
}

export default CategoryBar;
